import { appendQueryStringToPath } from "@faire/retailer-visitor-shared/lib/pathUtils";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { Path } from "@faire/web--source/common/Path";
import { IRetailerUserNotificationMessage } from "@faire/web-api--source/indigofair/retailer/IRetailerUserNotificationMessage";
import { useLocation } from "react-router-dom";

/**
 * Returns the path of a notification message.
 * If the notification path starts with "?", it is appended to the current path.
 * Otherwise, the notification path is returned directly.
 * If the notification path is undefined, the home path is returned.
 *
 * @param message
 */
export const useNotificationMessagePath = (
  message: IRetailerUserNotificationMessage | undefined
) => {
  const location = useLocation();

  const notificationPath = message?.path?.startsWith("?")
    ? appendQueryStringToPath(new Path(location), message.path).toString()
    : message?.path;

  return notificationPath ?? home();
};
